// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-QzM","fullView":"styles_fullView__37PX0"};